module.exports = __webpack_public_path__ + "media/loans/sallie-mae-bae61424.svg";